import type { IVenueList } from 'models/organizations'
import type { IUserProfile } from 'models/userProfiles'

export enum UserProfileStatus {
	initial = 'initial',
	anonymous = 'anonymous',
	loading = 'loading',
	loaded = 'loaded'
}

export interface UserProfileContextValue {
	userProfile: IUserProfile | undefined
	setUserProfile: React.Dispatch<React.SetStateAction<IUserProfile | undefined>>
	userProfileStatus: UserProfileStatus
	setUserProfileStatus: React.Dispatch<React.SetStateAction<UserProfileStatus>>
	useUpdatePreviewExperience: ({
		userProfileId,
		previewExperienceKey,
		enable
	}: {
		userProfileId?: string
		previewExperienceKey: string
		enable: boolean
	}) => unknown
	setImpersonatedUserId?: React.Dispatch<React.SetStateAction<string | null>>
	impersonatedUserId?: string | null
	resetImpersonation?: () => void
	venueList: IVenueList[]
}
